import _ from "lodash";
import React from "react";
import styled, { css } from "styled-components";
import { Radio } from "antd";
import { Controller } from "react-hook-form";
import { InputContainer } from "../../job/add/form/jobTypeRadio";

// const { Option } = Select;

function TSimpleRadio(props) {
  const {
    name,
    setValue,
    options,
    errors,
    control,
    defaultValue,
    trigger,
    cssHide,
    className,
    size,
    buttonStyle,
    noMt,
    onPilih,
    value,
  } = props;

  return (
    <CheckboxContainer>
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        render={() => {
          return (
            <StyledRadioGroup
              className={className}
              size={size}
              style={{ display: cssHide && "none" }}
              optionType="button"
              buttonStyle={buttonStyle || ""}
              defaultValue={defaultValue}
              onChange={(e) => {
                setValue(name, e.target.value, {
                  shouldDirty: true,
                });
                trigger(name);
                if (onPilih) {
                  onPilih.func(onPilih.printColorIndex, onPilih.index);
                }
              }}
              noMt={noMt}
              error={errors && _.get(props.errors, props.name)}
            >
              {options.map((option, index) => (
                <Radio.Button value={option} key={`option-${index}`}>
                  {option}
                </Radio.Button>
              ))}
            </StyledRadioGroup>
          );
        }}
      />
      {errors && _.get(props.errors, props.name) && (
        <StyledError style={{ display: cssHide && "none" }}>
          <p>{errors && _.get(props.errors, props.name).message}</p>
        </StyledError>
      )}
    </CheckboxContainer>
  );
}

const StyledRadioGroup = styled(Radio.Group)`
  .ant-radio-button-wrapper {
    margin-top: ${(props) => props.theme.spacing[1]};
  }
  ${(props) =>
    props.error &&
    css`
      .ant-radio-button-wrapper {
        border: 1px solid ${(props) => props.theme.colors.red[600]};
        color: ${(props) => props.theme.colors.red[600]};
      }
    `};

  ${(props) =>
    props.noMt &&
    css`
      .ant-radio-button-wrapper {
        margin-top: 0;
      }
    `};
`;

const StyledError = styled.span`
  color: ${(props) => props.theme.colors.red[600]};
  padding: 0;
  margin: 0;

  p {
    font-size: 0.8rem;
    margin: 0;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default TSimpleRadio;
